import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink, withRouter } from "react-router-dom";
import { GameImage } from './GameImage.jsx'

export class GameDialog extends React.Component {
    GAMECODE_1BoxBlackJack = 'BJ_SB-Mini_BJ';

    constructor(props) {
        super(props);
        this.state = {
            showStrategije: false,
            goToLogin: false, // idi na login ako treba pokrenuti odmah igru
            gameStarted: false, // pokrenuta je igra, poslan ajax
        };

        this.startDemo = this.startDemo.bind(this);
        this.startReal = this.startReal.bind(this);
        this.startGame = this.startGame.bind(this);
        this.showStrategije = this.showStrategije.bind(this);
        this.hideStrategije = this.hideStrategije.bind(this);
        this.toggleFavorit = this.toggleFavorit.bind(this);
        this.renderFavoritStar = this.renderFavoritStar.bind(this);
        this.renderJackpot = this.renderJackpot.bind(this);
        this.renderGumbi = this.renderGumbi.bind(this);
        this.renderStrategijeText = this.renderStrategijeText.bind(this);
        this.SendGamePositionData = this.SendGamePositionData.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // update samo ako posotji igra, ako nestane igra onda ne mičemo nego ostavimo, zbog animacije, updejtamo i ako se zamjeni tab
        return !!nextProps.igra || nextProps.selectedCategoryId != this.props.selectedCategoryId;
    }

    // nepotrebno ?
    // componentWillUpdate(nextProps, nextState) {
    //     if (this.state.showStrategije) {
    //         if (!!nextProps.igra && nextProps.igra.sifra != this.GAMECODE_1BoxBlackJack) {
    //             this.hideStrategije();
    //         }
    //         if (!this.props.igra) {
    //             this.hideStrategije();
    //         }
    //     }
    // }

    componentDidMount() {
        if (!this.state.gameStarted) {
            if (this.props.igra && this.props.forceMoneyPlay && this.props.user) {
                this.setState({ gameStarted: true });
                this.startReal();
            }
            if (this.props.igra && this.props.forceMoneyPlay && !this.props.user) {
                this.setState({ goToLogin: true });
            }
        }
    }

    startDemo() {
        this.createGoogleTagEvent(true);
        this.props.showLoadingFn(true);
        var startedFrom = this.props.route.location.query && casino.utils.capitalizeFirstLetter(this.props.route.location.query.from);

        if (typeof ga !== 'undefined')   // google analytics
        {
            if (startedFrom)
                ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'IgrajDemoFrom' + startedFrom }); //, eventLabel: this.props.sesijaId});
            else
                ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'IgrajDemo' }); //, eventLabel: this.props.sesijaId });
        }

        if (casino.config.startGameInIframe) {
            const backUrl = casino.utils.getGameBackUrl(this.props.igra.id, this.props.selectedCategoryId, startedFrom);
            const gameUrl = casino.utils.getBaseUrl() + "gamelauncher/demo?id=" + this.props.igra.id + "&backUrl=" + backUrl;

            // Navigate to the game URL
            window.location.assign(gameUrl);
        }
        else {
            casino.repos.gameRepo.get(this.props.igra.id, true, this.props.selectedCategoryId, startedFrom).then(this.startGame);

        }
    }

    startReal() {
        this.createGoogleTagEvent(false);
        this.props.showLoadingFn(true);
        var startedFrom = this.props.route.location.query && casino.utils.capitalizeFirstLetter(this.props.route.location.query.from);

        if (typeof ga !== 'undefined') // google analytics
        {
            if (startedFrom)
                ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'IgrajFrom' + startedFrom }); //, eventLabel: this.props.sesijaId  });
            else
                ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'Igraj' }); //, eventLabel: this.props.sesijaId });
        }

        if (casino.config.startGameInIframe) {
            var backUrl = casino.utils.getGameBackUrl(this.props.igra.id, this.props.selectedCategoryId, startedFrom);
            var gameUrl = casino.utils.getBaseUrl() + "gamelauncher/real?id=" + this.props.igra.id + "&backUrl=" + backUrl;

            window.location.replace(gameUrl);
        } else {
            casino.repos.gameRepo.get(this.props.igra.id, false, this.props.selectedCategoryId, startedFrom).then(this.startGame);
        }
    }

    startGameplay(isDemo) {
        this.SendGamePositionData(isDemo, () => {

            this.createGoogleTagEvent(isDemo); // Google Tag tracking

            this.props.showLoadingFn(true);

            const startedFrom = this.props.route.location.query && casino.utils.capitalizeFirstLetter(this.props.route.location.query.from);

            // Google Analytics tracking
            if (typeof ga !== 'undefined') {
                if (startedFrom) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Clicks',
                        eventAction: isDemo ? 'IgrajDemoFrom' + startedFrom : 'IgrajFrom' + startedFrom
                    });
                } else {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Clicks',
                        eventAction: isDemo ? 'IgrajDemo' : 'Igraj'
                    });
                }
            }

            if (this.props.igra && casino.config.startGameInIframe) {
                const backUrl = casino.utils.getGameBackUrl(this.props.igra.id, this.props.selectedCategoryId, startedFrom, this.props.urlParam);
                let gameUrl = casino.utils.getBaseUrl() + `gamelauncher/${isDemo ? "demo" : "real"}?id=${this.props.igra.id}&backUrl=${backUrl}`;

                window.location.replace(gameUrl);
            } else {
                casino.repos.gameRepo
                    .get(this.props.igra.id, isDemo, this.props.selectedCategoryId, startedFrom)
                    .then(this.startGame.bind(this));
            }
        });
    };

    startGame(game) {
        this.props.showLoadingFn(false);
        window.location.replace(game.url);
    }

    showStrategije() {
        this.setState({ showStrategije: true });
    }

    hideStrategije() {
        this.setState({ showStrategije: false });
    }

    toggleFavorit() {
        this.props.toggleFavoritGameFn(this.props.igra);
    }

    createGoogleTagEvent(demo) {
        //Google tag manager
        var kategorijeArray = [];
        if (this.props.categories) {
            Object.keys(this.props.igra.kt).forEach(key => {
                var filterKategorija = this.props.categories.find(x => x.id == key);
                if (filterKategorija)
                    kategorijeArray.push(filterKategorija.name);
            });


            var gameTags = '';
            if (this.props.tags && this.props.igra.t) {
                Object.keys(this.props.igra.t).forEach(key => {
                    gameTags += this.props.tags[key] + ', ';
                });
                gameTags = gameTags.slice(0, -2);
            }

            //GA360
            var gameIsFavorit = this.props.user && this.props.user.favoriti && this.props.user.favoriti.indexOf(this.props.igra.id) !== -1 ? true : false;

            casino.utils.createGoogleTagManagerEvent({
                'event': 'gameOpen',
                'component.gameName': this.props.igra.id,
                'component.gameType': this.props.brands[this.props.igra.bID].name,
                //'component.Game.section': { {game section } } // this is a dynamic value to know which section the game is from 
                //'component.Game.position': { {game position } } // this is dynamic value to know Position of the game on the page
                'component.gameStatus': this.props.igra.p != undefined && this.props.igra.p && this.props.igra.p.indexOf("n") != -1 ? true : false,
                'component.gameFavourite': gameIsFavorit,
                //'component.gamePlayingStatus': { { Unfinished / Start } } //This is to know the status of the game
                'component.gameDisplayName': this.props.igra.n,
                'component.categoryType': (kategorijeArray ? kategorijeArray.join() : ''),
                'component.categorySubType': gameTags
            })

            casino.utils.createGoogleTagManagerEvent({
                'event': 'game_started',
                'game_click': demo ? 'isprobaj' : 'zaigraj',
                'game_name': this.props.igra.n,
                'game_provider': this.props.brands[this.props.igra.bID].name,
                'game_type': kategorijeArray ? kategorijeArray.join() : '',
                'jackpot': this.props.igra.jp != null ? 'yes' : 'no',
                'jackpot_amount': this.props.igra.jp ? this.props.igra.jp : 0,
                'gameId': this.props.igra.id,
                'maintenance': this.props.igra.p && (this.props.igra.p.indexOf("o") != -1) ? true : false,
                'new': this.props.igra.p && this.props.igra.p.indexOf("n") != -1 ? true : false,
                'exclusive': this.props.igra.ekskluzivno
            });
        }
    }

    renderFavoritStar() {
        if (this.props.userChecked && this.props.user) {
            var starClass = this.props.user.favoriti.indexOf(this.props.igra.id) == -1 ? "star-outline" : "star-fill";
            return (
                <span className={'icon icon-favorit ' + starClass} onClick={this.toggleFavorit}></span>);
        }
        return null;
    }

    //renderJackpot() {
    //    return <div className="jackpot-dialog" >
    //        <div className="jackpot-dialog--image"></div>

    //        <div className="labeled-divider divider--dark">
    //            {this.props.igra.jp > 0 && <table>
    //                <tbody>
    //                    <tr>
    //                        <td><span></span></td>
    //                        {this.props.igra.jp > 0 && <td className="divider-name strong">
    //                            {casino.utils.numberWithCurrencyFromated(this.props.igra.jp, this.props.igra.v)}
    //                        </td>}
    //                        <td><span></span></td>
    //                    </tr>
    //                </tbody>
    //            </table>}

    //            {this.props.igra.jp <= 0 && <br></br>}
    //        </div>

    //    </div>

    //}

    renderJackpot() {
        return (
            <>
                <div className="jackpot-container">
                    <div className="jackpot-image"></div>
                    <div className="jackpot-amount">{casino.utils.numberWithCurrencyFromated(this.props.igra.jp, this.props.igra.v)}</div>
                </div>
            </>
        )
    }

    renderAdditionalText(igra) {

        if (igra.s == 'BJ21-Blackjack_21' && new Date() < new Date(2019, 11, 1, 22, 29, 59) && new Date() > new Date(2019, 10, 29, 0, 0, 1))
            return <div className='margin-bottom-small' style={{ marginTop: '-10px' }}>
                Black Friday SuperSport groznica - Od <b>petaka, 29.11., do nedelje, 1.12., </b> vam poklanjamo <b>20 besplatnih ruku</b> - Akcija traje do isteka zaliha - Igranjem promocije prihvaćate <a style={{ color: '#3db3f2' }} target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/Black%20Friday_2019.pdf?c=${casino.config.guiCacheVerzija}`}>pravila</a>
            </div>
    }

    // #region GamePosition Logika, HizmanB

    // GamePosition logika, punjenje GamePosition podataka u objekt, HizmanB
    SendGamePositionData(isDemo, callback) {
        const trackingData = this.props.trackingData;
        const igraID = this.props.igra ? this.props.igra.id : 0;

        if (!trackingData || !trackingData.pageName) {
            console.log("Slanje otkazano: trackingData nemaju pageName.");
            if (callback) callback();
            return;
        }

        const gamePositionObj = {
            Page: trackingData.pageName,
            GamePosition: trackingData.gamePosition,
            PositionType: trackingData.positionType,
            ComponentName: trackingData.componentName,
            ComponentPosition: trackingData.componentPosition,
            BannerName: trackingData.bannerName,
            BannerPosition: trackingData.bannerPosition,
            IsIcon: trackingData.isIcon,
            TabName: trackingData.tabName,
            TabPosition: trackingData.tabPosition,
            SliderName: trackingData.sliderName,
            SliderPosition: trackingData.sliderPosition,
            Filter: trackingData.filter
        };

        const positionJsonString = JSON.stringify(gamePositionObj);

        return new Promise((resolve) => {
            const controller = new AbortController();
            const { signal } = controller;

            const timeoutId = setTimeout(() => {
                controller.abort();
                if (callback) callback();
                resolve();
            }, 1000);

            fetch('api/GamePosition', {
                method: 'POST',
                signal: signal,
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    IgraID: igraID,
                    PositionJson: positionJsonString,
                    IsDemo: isDemo
                })
            })
                .then(response => {
                    clearTimeout(timeoutId);


                    if (callback) callback();
                    resolve();
                })
                .catch(error => {
                    clearTimeout(timeoutId);

                    if (error.name !== 'AbortError') {
                        if (callback) callback();
                    }
                    resolve();
                });
        });
    }
    //#endregion

    renderGumbi() {
        const odrzavanje = this.props.igra.p && (this.props.igra.p.indexOf("o") != -1)
        const hideDemo = this.props.igra.p && (this.props.igra.p.indexOf("sd") != -1) // Why do we need this??
        const igraBrend = this.props.brands && this.props.brands[this.props.igra.bID].nameNormalizirano;
        const viseOIgriLink = `https://mcasino.supersport.hr/game/${igraBrend}/${casino.utils.normalizeString(this.props.igra.n)}/info`;

        return (
            <>
                <div className="buttons-container">
                    <div className={this.props.userChecked ? 'button-switcher' : 'hidden'}>
                        <div className={this.props.user ? 'play-button' : 'hidden'}>
                            <a
                                onClick={() => {
                                    // Startanje igre i slanje GamePosition podataka na controller, HizmanB
                                    this.startGameplay(false);
                                }}
                            >
                                <span className="play-symbol" disabled={odrzavanje} />
                                <span className="button-text">ZAIGRAJ</span>
                            </a>
                        </div>
                        <div className={!this.props.user ? 'login-button' : 'hidden'}>
                            <NavLink to={{ pathname: "/login", state: { from: this.props.route.location } }} disabled={odrzavanje}
                                onClick={() => this.props.showSearchFn && this.props.showSearchFn(false)} >
                                <span className="play-symbol" disabled={odrzavanje} />
                                <span className="button-text">PRIJAVI ME I IGRAJ</span>
                            </NavLink>
                        </div>
                    </div>
                    {(!this.props.igra?.p?.includes("sd") || !this.props.igra?.p?.includes("ns")) && <div className="bottom-buttons">
                        {!this.props.igra?.p?.includes("sd") && <a className="try-button" onClick={() => {
                            // Startanje igre i slanje GamePosition podataka na controller, HizmanB
                            this.startGameplay(true);
                        }
                        }
                            disabled={odrzavanje}>ISPROBAJ</a>}
                        {!this.props.igra?.p?.includes("ns") &&
                            <a className={"find-out-more" + (this.props.igra?.p?.includes("sd") ? "  no-left-margin" : "")} onClick={() => { window.location.href = viseOIgriLink; }}>
                                VIŠE O IGRI
                            </a>
                        }
                    </div>}
                </div>
                {
                    // ! Removed strategies button
                    //this.props.igra.s == this.GAMECODE_1BoxBlackJack && !this.state.showStrategije ?
                    //    <button className="btn medium fill gray-blue  as-block margin-top-xsmall margin-bottom-small new-badge"
                    //        onClick={this.showStrategije}>
                    //        <span>Strategije i prijedlozi</span>
                    //    </button>
                    //    : null
                }
            </>
        )
    }

    renderStrategijeText() {
        return <div className="text-justify">
            <b>Unaprijedi igru</b><div className="margin-bottom-small" />
            Funkcionalnost <b>"Strategija"</b> omogućuje da svaki potez unaprijed isplaniraš, u igri bolje reagiraš i pobijediš. <div className="margin-bottom-small" />
            Uključi u postavkama!!
        </div>
    }

    render() {
        // ako je moramo forsirati igru a nije prijavljen onda login
        if (this.state.goToLogin)
            return <Redirect to={{ pathname: "/login", state: { from: this.props.route.location } }} />;

        // ako je igra pokrenuta ne crtaj gui, ovo je direktno startanje igre
        if (this.state.gameStarted)
            return null;

        if (!this.props.igra)
            return null;
        if (this.state.showStrategije)

            return <div>
                <div className="game-dialog-header clearfix">
                    <button className="pull-left link link-1" onClick={this.hideStrategije}>
                        <span className="back-icon icon ico-chevron-left"></span>
                    </button>
                    <NavLink to={this.props.routePrefix || '' + '/'} className="pull-right link link-1">
                        <span className="close-icon icon ico-close-thin"></span>
                    </NavLink>
                    <div className="text-center text text-5 text-bold">
                        Strategije i prijedlozi
                    </div>
                </div>

                <div className="game-dialog-container">
                    <div className="game-dialog-container--inner flex-equal-size">
                        <div>
                            <img className="strategija--image" src="Content/Images/Assets/blackjack-strategije.jpg" />
                            <div className="landscape-hidden">
                                {this.renderStrategijeText()}
                            </div>
                            <div className="margin-bottom"></div>
                            {this.renderGumbi()}
                        </div>
                        <div className="portrait-hidden margin-left">
                            {this.renderStrategijeText()}
                            <div className="margin-bottom-xsmall">  </div>
                            <div className="margin-bottom-xsmall">  </div>
                        </div>
                    </div>
                    <div className="margin-bottom-small">  </div>
                    <div className="margin-bottom-xsmall">  </div>
                </div>
            </div>

        let maintenanceClass = this.props.igra && this.props.igra.p && (this.props.igra.p.indexOf("o") != -1) ? 'maintenance ' : '';
        //console.log(this.props.igra);

        return <div className="game-dialog--outer-wrapper">
            <div className="game-dialog-header clearfix">
                <div className="top-rectangle"></div>
                <div className="game-name">
                    {this.renderFavoritStar()}
                    <h1 className="naziv-igre">{this.props.igra.n}</h1>
                </div>
                <NavLink to={this.props.routePrefix || '' + '/'} className="pull-right link link-1">
                    { /*<span className="portrait-hidden">Zatvori prozor</span> */}
                    <span className="close-icon icon ico-close-thin"></span>
                </NavLink>
                {/*{this.props.igra.help ? <a target="_blank" className="pull-right link link-3 circle" href={this.props.igra.help}><span>?</span></a> : null}*/}
            </div>
            <div className={"game-dialog-container " + maintenanceClass}>
                <div className="game-dialog-container--inner flex-equal-size">
                    <div style={{ marginTop: '1rem' }}>
                        <GameImage igra={this.props.igra} brands={this.props.brands} bigPicture="true" categories={this.props.categories}></GameImage>
                        <div className="landscape-hidden">
                            {this.props.igra.jp > 0 && this.renderJackpot()}
                            {this.renderGumbi()}
                        </div>
                    </div>
                    <div className="portrait-hidden margin-left">
                        {this.props.igra.jp > 0 && this.renderJackpot()}
                        {this.renderGumbi()}
                    </div>
                </div>
                {/*
                        <div className="text-center landscape-hidden">
                            <hr />
                            <ReactRouterDOM.NavLink to={this.props.routePrefix || '' + '/'} className="link link-2 text-center"><span>Zatvori prozor</span></ReactRouterDOM.NavLink>
                        </div>
                        <div className="margin-bottom-small portrait-hidden">  </div>
                    */}
                <div className="margin-bottom-small">  </div>
                <div className="margin-bottom-xsmall">  </div>
            </div>
        </div>
    }
};
